// Dropdown options for the expertise/affiliation profile fields. Shared
// by the SignUp form and the Google-signup CompleteProfile form so the
// two never drift.

export const EDU_OPTIONS = [
  { value: "", label: "Highest degree complete" },
  { value: "None", label: "No schooling complete" },
  { value: "SomeHS", label: "Some high school, no diploma" },
  { value: "HS", label: "High school graduate / GED" },
  { value: "SomeCollege", label: "Some college, no degree" },
  { value: "TradeSchool", label: "Trade / vocational" },
  { value: "AA", label: "Associate degree" },
  { value: "BS", label: "Bachelor's degree" },
  { value: "MS", label: "Master's degree" },
  { value: "Professional", label: "Professional degree" },
  { value: "Ph.D.", label: "Doctorate" },
];

export const YEAR_OPTIONS = [
  { value: "", label: "Years of experience" },
  { value: "<0.5", label: "Less than 6 months" },
  { value: "0.5-1", label: "6 to 12 months" },
  { value: "1-3", label: "1 to 3 years" },
  { value: "4-6", label: "4 to 6 years" },
  { value: "7+", label: "7 or more years" },
];

export const CLEAN_OPTIONS = [
  { value: "", label: "Select frequency" },
  { value: "week", label: "At least once a week" },
  { value: "month", label: "At least once a month" },
  { value: "year", label: "At least once a year" },
];
